module.exports = __webpack_public_path__ + "static/media/medicaInicioQuestionario.fd147449.svg";